import { defineMessages } from 'react-intl';

export default defineMessages({
  unspecifiedType: {
    id: 'conditionEditor.unspecifiedType',
    defaultMessage: 'Unspecified Attribute Type!',
  }
});